<template>
  <div
    class='b-input-v4'
    :class='{ "field_with_errors": !!error }'
  >
    <input
      :id='hash'
      ref='inputRef'
      :placeholder='label'
      :type='type'
      :value='isCheckbox ? undefined : modelValue'
      :checked='isCheckbox ? modelValue : undefined'
      @input='inputChange($event)'
    >

    <label
      v-if='isCheckbox'
      :for='hash'
      tabindex='0'
      @keypress.space='toggleCheckbox'
      @click='blurCheckboxFocus'
    ><span v-html='label' /></label>
    <label v-else :for='hash' v-html='label' />

    <span v-if='error && !isBoolean(error)' class='error-message'>{{ error }}</span>
  </div>
</template>

<script>
export default { name: 'AppInput' };
</script>

<script setup>
import { ref, computed } from 'vue';
import isBoolean from 'lodash/isBoolean';

import inputHash from '@/helpers/input_hash';

const props = defineProps({
  type: {
    type: String,
    required: false,
    default: 'text',
    validator: value => ['text', 'email', 'number', 'password', 'checkbox'].includes(value)
  },
  label: { type: String, required: false, default: undefined },
  error: { type: [String, Boolean], required: false, default: false },
  modelValue: { type: [Number, String, Boolean], required: false, default: undefined }
});

const emit = defineEmits(['update:modelValue']);
// const model = defineModel({ type: [Number, String, Boolean] });
const isCheckbox = computed(() => props.type === 'checkbox');

const hash = inputHash();
const inputRef = ref(null);

function inputChange(event) {
  if (isCheckbox.value) {
    emit('update:modelValue', event.target.checked);
  } else {
    const value = event.target.value;
    const isNumber = props.type === 'number';
    let fixedValue = isNumber ? parseFloat(value) : value;
    if (isNumber && isNaN(fixedValue)) { fixedValue = 0; }

    emit('update:modelValue', fixedValue);
  }
}

function toggleCheckbox(e) {
  e.preventDefault();
  emit('update:modelValue', !props.modelValue);
}

function blurCheckboxFocus(e) {
  e.currentTarget.blur();
}

// const isValid = computed(() => !!props.modelValue);
defineExpose({
 // isValid
  focus() {
    inputRef.value.focus();
  }
});
</script>

<style scoped lang='sass'>
</style>
